import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { isEmpty } from 'lodash';
import { LOGIN_ATTEMPT_ID, VERIFICATION_CODE } from '../account.data';

@Injectable()
export class VerifyLoginGuard implements CanActivate {
  constructor(private _router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): UrlTree | boolean {
    const queryParamMap = route.queryParamMap;
    const validQueryParams =
      !isEmpty(queryParamMap.get(LOGIN_ATTEMPT_ID)) &&
      !isEmpty(queryParamMap.get(VERIFICATION_CODE));

    return validQueryParams || this._router.parseUrl('/login');
  }
}
